import type { UseQueryOptions } from '@tanstack/vue-query'
import type { MaybeRef } from 'vue'
import { getError } from '@autobid/strapi-integration/utils/getError'
import { useQuery, useQueryClient } from '@tanstack/vue-query'

export function useNote(
  carId: MaybeRef<number>,
  options?: UseQueryOptions<string, Error>,
) {
  const queryClient = useQueryClient()
  const push = usePush()
  const { $trpc } = useNuxtApp()

  const queryFn = async () => {
    return await $trpc.webapi.getNote.query({ carId: unref(carId) })
  }

  const { data: note, ...rest } = useQuery({
    queryKey: ['note', unref(carId)],
    queryFn,
    onError: (error: unknown) => {
      const { message, handled } = getError(error)

      if (!handled) {
        push.error(message)
      }
    },
    ...(options ?? {}),
  })

  const prefetch = () =>
    queryClient.prefetchQuery({
      queryKey: ['note', unref(carId)],
      queryFn,
    })

  return { note, prefetch, ...rest }
}
